export default __webpack_public_path__ + "static/media/logo-proyecto.c50ad71b.svg";